module.exports = __webpack_public_path__ + "img/failResult.c43d601a.svg";